const ddadosSolicitacao = {
  Titulo: "Solicitação",
  Campos: {
    Numero: {
      Tipo: "text",
      Label: "Número",
      Desabilitado: true
    },
    CpfCnpjSolicitacao: {
      Tipo: "mask",
      Mascara: "CPFCNPJ",
      Label: "CPF/CNPJ",
      Obrigatorio: true
    },
    TipoSolicitacao: {
      Tipo: "combobox",
      Label: "Tipo de Solicitação",
      Obrigatorio: true
    },
    CCM: {
      Tipo: "combobox",
      Label: "CCM"
    },
    SituacaoSolicitacaoDescricao: {
      Tipo: "text",
      Label: "Situação da Solicitação",
      Desabilitado: true
    },
    DescricaoSolicitacao: {
      Tipo: "textarea",
      Label: "Histórico da Ocorrência / Motivo da Solicitação",
      Tamanho: 2000,
      Obrigatorio: true
    },
    MotivoRetificacao: {
      Tipo: "textarea",
      Label: "Motivo da Retificação",
      Tamanho: 2000,
      Obrigatorio: true
    }
  }
};

export { ddadosSolicitacao };
